import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { Device } from '../../devices.model_new';
import { DeviceTypesMap, DeviceType, GROUP } from '../../devices.constant';
import { CategoriesService } from '../../categories.service';
import { SessionStateService } from '../../../../core/services/session-state.service';
import { SharedUtils } from '../../../../shared/shared.utils';
import { DevicesService } from '../../devices.service';
import { STATE_VAR } from '../../../../entities/devices/devices.constant';
import { IotService } from '../../../../core/services/iot.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-consumption-detail',
  templateUrl: './consumption-detail.component.html',
  styleUrls: ['./consumption-detail.component.scss']
})
export class ConsumptionDetailComponent implements OnInit, OnDestroy {

@Input()
device: Device;
categoryName: string;
DeviceTypesMap = DeviceTypesMap;
DeviceType = DeviceType;
SharedUtils = SharedUtils;
GROUP = GROUP;
STATE_VAR = STATE_VAR;
loaded;
mode;

realTimeSubscription: Subscription;

  constructor(private categoriesService: CategoriesService,
              private sessionSateService: SessionStateService,
              private devicesService: DevicesService,
              private iotService: IotService) { }

  ngOnInit() {
    this.iotService.connect();
    this.getDeviceCategory();
    this.obtainRealTimeResponses();
  }

  getProperties(type: string) {
    return DeviceTypesMap.map.get(DeviceType.CONSUMPTION).properties[type];
  }

  isTrue(value: string) {
    return (value === 'True' || value === 'true' || value === 'TRUE' || value);
  }
  isFalse(value: string) {
    return (value === null || value === 'False' || value === 'false' || value === 'FALSE' || !value);
  }

  getDeviceCategory() {
    this.categoriesService.getCategories()
    .subscribe(res => res.subscribe(resCategories => {
      resCategories.forEach(cat => {
        if (cat.id === this.device.getUserAttribute('category')) {
          this.categoryName = cat.name;
        }
      });
    }));
  }

  presentCategory(cat: string) {
    return cat.charAt(0).toUpperCase() + cat.substr(1, cat.length).toLowerCase().split('_').join(' ');
  }

  onSwitch(event) {
    if (!this.device.getUserAttribute('locked')) {
      event.stopPropagation();
      const stateVar = this.device.getStateVar(STATE_VAR.RELAY_STATE);
      this.iotService.updateModule(this.device, STATE_VAR.RELAY_STATE, !stateVar.value);
    }
  }

  ngOnDestroy(): void {
    if(this.realTimeSubscription) {
      this.realTimeSubscription.unsubscribe();
    }
  }

  getLoading(): boolean {
    return this.iotService.isUpdatingModule(this.device.getModuleLocalId());
  }

  private obtainCachedResponses(): void {
    this.iotService.responseHistory.forEach((message, moduleLocalId) => {
      this.processMessage(message);
    }
    );
  }

  private obtainRealTimeResponses(): void {
    this.obtainCachedResponses();
    if (this.iotService.messagesObserver) {
      this.realTimeSubscription = this.iotService.messagesObserver.subscribe(
        message => {
          this.processMessage(message);
        }
      );
    }
  }

  private processMessage(message: any): void {
    if (this.device !== undefined) {
      const platformKey = message.platformKey;
      if (message.moduleLocalId === this.device.getModuleLocalId()) {
        if (platformKey !== STATE_VAR.CONNECTIVITY_STATE) {
          const statVar = this.device.getStateVar(platformKey);
          if (statVar) {
            statVar.value = message.value;
          }
        } else {
          this.device.setConnectivityState(message.value);
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/entities/devices/device-detail/consumption-detail/consumption-detail.component.ts